import { normalizeBogglePlaygroundSettings } from '~/boggle/lib/playground'
import { RACE_CORE_PRESET } from '../race/preset'

export const SPRINT_CORE_PRESET = normalizeBogglePlaygroundSettings(
  {
    intervalCount: 10,
    intervalTimeSeconds: 6,
    endIntervalOnSubmit: true,
    scoreBonusMaxLength: null,
    gridSize: '3x3',
    specialTiles: {
      gold: {
        countAtStart: 2,
        spawnEveryXTiles: 0,
        maximumCount: 2,
      },
    },
  },
  RACE_CORE_PRESET,
)
